import { Component, OnInit} from '@angular/core';
import { SeoService } from '@services/seo.service';

@Component({
    selector: 'app-abg',
    templateUrl: './agb.component.html',
    styleUrls: ['./agb.component.scss']
})

export class AGBComponent implements OnInit {

    constructor(
        private seoService: SeoService,
    ) { }

    ngOnInit() {
        this.seoService.set({
            title: 'AGB | Spieloguide',
            description: 'Allgemeine Geschäftsbedingungen von Spieloguide.',
            path: '/agb'
        });
    }
}
